<template>
    <div class="log" v-if="loaded">

        <div class="row mb-3">
            <div class="col-md-6">
                <div v-if="!empty">
                    <base-button type="white mr-1" size="sm" @click="$refs['timeslots-collapse'].expandAll()">
                        <i class="fas fa-chevron-down"></i>
                        {{ $t('common.expand-all') }}
                    </base-button>
                    
                    <base-button type="white" size="sm" @click="$refs['timeslots-collapse'].collapseAll()">
                        <i class="fas fa-chevron-up"></i>
                        {{ $t('common.collapse-all') }}
                    </base-button>
                </div>
            </div>
            <div class="col-md-6 text-right" style="padding-right:40px">
                <actions-dropdown :actions="mainActions()" v-if="canEditAll"></actions-dropdown>
            </div>
        </div>

        <card v-if="empty" class="mb-3">
            <p class="mb-0">{{ $t('timeslots.no-timeslot') }}</p>
        </card>

        <collapse class="timeslots pb-2" ref="timeslots-collapse" :multiple-active="true">

            <div v-for="timeslot in ctrl.rows" :key="timeslot.id">

                <collapse-item-card :id="'timeslot-'+timeslot.id" class="mb-3" :active-default="false" :ref="'timeslot-'+timeslot.id">
                
                    <template slot="title">
                        <div class="row align-items-center pl-4">
                            <div class="col" style="flex: 0 0 80px">
                                <h5 class="mb-0 float-left" style="font-size:1.1rem;font-weight:700">
                                    <!--
                                    <i class="fas fa-clock mr-2" style="font-size:1rem"></i>
                                    -->
                                    {{ timeslot.time }}
                                </h5>
                            </div>
                            <div class="col pl-0">
                                <h6 class="font-weight-normal text-sm text-uppercase mb-0">
                                    {{ timeslot.instructor_summary }}
                                </h6>
                            </div>
                            <div class="col text-right" style="flex: 0 0 160px">

                                <a href="#" class="table-action text-danger" v-if="canEditAll"
                                    @click.prevent.stop="ctrl.remove(timeslot.id)"
                                >
                                    <i class="tim-icons icon-simple-remove"></i>
                                </a>

                                <a href="#" class="table-action text-primary" v-if="canEdit"
                                    @click.prevent.stop="updateTimeslot(timeslot)"
                                >
                                    <i class="tim-icons icon-pencil"></i>
                                </a>

                                <actions-dropdown :actions="timeslotActions(timeslot)"></actions-dropdown>
                            </div>
                        </div>
                    </template>

                    <template>
                        <items-crud :lang="lang"
                            :timeslot="timeslot"
                            :types="types"
                            :competencies="competencies"
                            :degree="degree"
                            ref="timeslot"
                            @selected="itemCtrl=$event"
                        >
                        </items-crud>
                    </template>

                </collapse-item-card>
            </div>
        </collapse>

        <div class="text-center fixed-bottom" v-if="canEditAll">

            <base-button type="primary" @click="ctrl.create()">
                <span class="btn-inner--icon"><i class="tim-icons icon-e-add"></i></span>
                <span class="btn-inner--text">{{ $t('common.timeslot') }}</span>
            </base-button>

            <base-button type="primary" @click="mixCtrl.create()">
                <span class="btn-inner--icon"><i class="tim-icons icon-e-add"></i></span>
                <span class="btn-inner--text">{{ $t('common.timeslot-with-item') }}</span>
            </base-button>
        </div>

        <back-to-top></back-to-top>

        <portal to="modals">

            <form-modal v-model="ctrl.modals.edit"
                :title="$t('common.timeslot')"
                :loading="ctrl.form.loading"
                size="lg"
            >
                <timeslot-form v-model="ctrl.form.data"
                    :errors="ctrl.form.errors"
                    :modal="ctrl.modals.edit"
                    :duplicating="ctrl.form.duplicating"
                >
                </timeslot-form>
            </form-modal>

            <form-modal v-model="mixCtrl.modals.edit"
                :title="$t('common.timeslot-with-item')"
                :loading="mixCtrl.form.loading"
                size="lg"
            >
                <timeslot-item-form v-model="mixCtrl.form.data"
                    :errors="mixCtrl.form.errors"
                    :modal="mixCtrl.modals.edit"
                    :types="types"
                    :competencies="competencies"
                    :degree="degree"
                >
                </timeslot-item-form>
            </form-modal>

            <confirm-modal v-model="ctrl.modals.confirmDelete">
                <p>{{ $t('timeslots.delete-confirm') }}</p>
            </confirm-modal>

            <form-modal v-model="itemCtrl.modals.edit"
                :title="$t('common.item')"
                :loading="itemCtrl.form.loading"
                size="lg"
                v-if="itemCtrl"
            >
                <item-form v-model="itemCtrl.form.data"
                    :errors="itemCtrl.form.errors"
                    :modal="itemCtrl.modals.edit"
                    :duplicating="itemCtrl.form.duplicating"
                    :types="types"
                    :competencies="competencies"
                    :degree="degree"
                >
                </item-form>
            </form-modal>

            <confirm-modal v-model="itemCtrl.modals.confirmDelete" v-if="itemCtrl">
                <p>{{ $t('items.delete-confirm') }}</p>
            </confirm-modal>

        </portal>
    </div>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import TimeslotForm from './TimeslotForm'
    import TimeslotItemForm from './TimeslotItemForm'
    import ItemsCrud from './ItemsCrud'
    import ItemForm from './ItemForm'

    export default {

        components: {
            TimeslotForm, TimeslotItemForm, ItemsCrud, ItemForm
        },

        props: {

            log: {
                type: Object,
                required: true
            },

            simulation: {
                type: Object,
                required: true
            },

            lang: {
                type: String,
                default: "fr"
            },
            
            degree: {
                type: Object,
                required: true
            },
        },

        data() {
            return {
                loaded: false,
                ctrl: new CrudController({
                    endpoint: '/astral/api/front/log-timeslots',
                    mapData: this.mapData,
                    unmapData: this.unmapData,
                    query: {
                        sort: ['time'],
                        include: ['types', 'competencies'],
                        relations: ['items']
                    },
                    callbacks: {
                        listed: this.timeslotListed,
                        created: this.timeslotCreated,
                        duplicated: this.timeslotCreated,
                    }
                }),
                mixCtrl: new CrudController({
                    endpoint: '/astral/api/front/log-timeslots-items',
                    mapData: this.mixMapData,
                    unmapData: this.mixUnmapData,
                    autolist: false,
                    callbacks: {
                        created: this.mixCreated
                    }
                }),
                itemCtrl: null,     // Set by items-crud @selected
                types: null,
                competencies: null,
                justCreatedTimeslotId: null,
            }
        },

        created() {

            // Main controller: timeslots.
            // For the first load, we want to load directly all the items of the timeslots
            // in a single request because it is faster.
            this.$loader.show()
            this.ctrl.query.filters = { log_id: this.log.id }
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
                this.types = resp.data.included.types
                this.competencies = resp.data.included.competencies
                this.ctrl.client.query.relations = []
                this.$nextTick(() => {
                    this.$loader.hide()
                })
            })

            // Secondary controller: mixed timeslots + items.
            this.mixCtrl.init(this, 'mixCtrl')
        },

        computed: {
            
            shared() {
                return this.degree.shared && this.$auth.user.owner_id && this.$auth.user.owner_id != this.degree.owner_id
            },

            canEdit() {
                return !this.shared && this.degree.status != 'archived'
            },
            
            canEditAll() {
                return !this.shared && this.degree.status != 'active' && this.degree.status != 'archived'
            },

            empty() {
                return this.ctrl.rows.length == 0
            }
        },

        methods: {

            updateTimeslot(timeslot) {
                this.ctrl.update(timeslot.id)
            },

            mainActions() {
                return [
                    {
                        label: this.$t('common.paste'),
                        handler: this.pasteTimeslot,
                    },
                ]
            },

            timeslotActions(timeslot) {
                let actions = []
                if (this.canEditAll) {
                    actions.push({
                        label: this.$t('common.duplicate'),
                        handler: this.duplicateTimeslot,
                        data: timeslot
                    })
                }
                actions.push({
                    label: this.$t('common.copy'),
                    handler: this.copyTimeslot,
                    data: timeslot
                })
                if (this.canEdit) {
                    actions.push({
                        label: this.$t('common.paste'),
                        handler: this.pasteItem,
                        data: timeslot
                    })
                }
                return actions
            },

            duplicateTimeslot(timeslot) {
                this.ctrl.duplicate(timeslot.id)
            },

            copyTimeslot(timeslot) {
                axios.post(this.ctrl.client.endpoint + '/' + timeslot.id + '/copy')
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            },

            pasteTimeslot() {
                axios.post('/astral/api/front/simulations/' + this.simulation.id + '/paste')
                .then(resp => {
                    this.ctrl.list()
                })
                .catch(err => {
                    if (err.response.status == 404) {
                        // Paste error. Do nothing.
                    } else {
                        this.$auth.handleErrorVm(err, this)
                    }
                })        
            },

            pasteItem(row) {
                axios.post(this.ctrl.client.endpoint + '/' + row.id + '/paste')
                .then(resp => {
                   // There is a confusion with indexes so we must call all the timeslots
                   // passing the timeslot ID to target the right one.
                   for (const timeslot of this.$refs.timeslot) {
                       timeslot.refresh(row.id)
                   }
                })
                .catch(err => {
                    if (err.response.status == 404) {
                        // Paste error. Do nothing.
                    } else {
                        this.$auth.handleErrorVm(err, this)
                    }
                })        
            },

            mapData(timeslot) {
                return {
                    id: timeslot ? timeslot.id : null,
                    time: timeslot ? timeslot.time : null,
                    instructor_summary: timeslot ? timeslot.instructor_summary : null,
                    position: timeslot ? timeslot.position : 0,
                    items: timeslot ? timeslot.items : [],
                }
            },

            unmapData(data) {
                data.log_id = this.log.id
                return data
            },

            mixMapData() {
                return {
                    time: null,
                    instructor_summary: null,
                    type: null,
                    simulation_role_1: true,
                    simulation_role_2: true,
                    description: '',
                    competency_ids: null,
                }
            },

            mixUnmapData(data) {
                let mix = {...data}
                mix.log_id = this.log.id
                return mix
            },

            timeslotCreated(resp) {
                this.justCreatedTimeslotId = resp.data.data.id
            },

            timeslotListed() {
                if (this.justCreatedTimeslotId) {
                    this.$nextTick(() => {
                        this.$refs['timeslots-collapse'].expandItem('timeslot-' + this.justCreatedTimeslotId)
                        this.justCreatedTimeslotId = null
                    })
                }
            },

            mixCreated(resp) {
                this.ctrl.list().then(() => {
                    this.$nextTick(() => {
                        this.$refs['timeslots-collapse'].expandItem('timeslot-' + resp.data.data.id)
                    })
                })
            },
        }
    }
</script>

<style scoped>

    .log .timeslots >>> .card-header {
        border-bottom: 0px solid;
    }
    .log .timeslots >>> .card-header:after {
        right: auto;
    }
    .log .timeslots >>> .card-body {
        padding: 0;
    }
    .log .timeslots >>> .card-body tr.el-table__row td {
        padding-top: 0;
        border-bottom: 0px solid;
    }
    a:focus {
        outline: none;
    }
    .popover-text {
        font-size: 0.875rem;
        margin-bottom: 0;
        font-weight: 400;
    }
    .fixed-bottom {
        position: sticky;
        bottom: 30px;
        z-index: 1000;
    }
    
</style>